import { useEffect, useState } from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useDisconnect } from 'wagmi';
import { useLocation } from 'react-router-dom';
import logo from '@/assets/logo.png';
import { loginOut } from "@/api/apiMethods.js";
import './head.css';
import userStore from '@/utils/userStore';
import apiClient from "@/api/apiClient";
import useDisconnectHandler from "@/utils/fn/useDisconnectHandler";
import vector from '@/assets/Vector.png';
import hamburger from '@/assets/app/hamburger-icon.png';

function Head() {
    const { disconnectWallet } = useDisconnectHandler();
    const { address, isConnected } = useAccount();
    const { disconnect } = useDisconnect();

    const location = useLocation();
    const [selectedLink, setSelectedLink] = useState(location.pathname);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        setSelectedLink(location.pathname);
    }, [location.pathname]);

    const fetchData = async (userData) => {
        await userStore.fetchUserInfo(userData);
    };

    const getLinkClassName = (path) => {
        const isMobile = window.innerWidth < 768;

        if (selectedLink === path) {

            return isMobile ? 'text-white' : 'text-white relative pb-1';
        } else {

            return 'text-gray-400 hover:text-white transition duration-200';
        }
    };


    const handleDisconnect = async () => {
        console.log('User disconnected from wallet');
        userStore.clearUser();
        await loginOut();
    };

    const goHome = () => {
        window.location.href = 'https://www.bitplay.fun/';
    };

    useEffect(() => {
        if (!isConnected) {
            handleDisconnect();
        }
    }, [isConnected]);

    const queryParams = new URLSearchParams(location.search);
    const inviteCode = queryParams.get("invite_code");
    useEffect(() => {
        if (isConnected && address && !userStore.user) {
            const userData = {
                address: address,
                uid: inviteCode,
            };
            fetchData(userData);
        } else {
            userStore.getUserInfo();
        }
    }, [isConnected, address]);

    useEffect(() => {
        const requestInterceptor = apiClient.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    console.log(123321123);
                    disconnectWallet();
                }
                return Promise.reject(error);
            }
        );

        return () => {
            apiClient.interceptors.response.eject(requestInterceptor);
        };
    }, [disconnectWallet]);

    return (
        <div className="flex items-center lg:justify-between justify-evenly w-full h-[100px] lg:px-8 relative">
            <div className="flex items-center space-x-8">
                <div className="text-white font-bold text-lg tracking-wider lg:block hidden">
                    <img src={logo} className="w-36 h-10" alt="" />
                </div>
                <nav className="hidden md:flex items-center space-x-6 text-base">
                    <a href="https://www.bitplay.fun/" className={getLinkClassName('https://www.bitplay.fun/')}>Home</a>
                    <a href="/games/" className={getLinkClassName('/games/')}>Games</a>
                    {/* <a href="/spin/" className={getLinkClassName('/spin/')}>Mission</a> */}
                    {/* <a href="/gamecard/" className={getLinkClassName('/gamecard/')}>Game Card</a> */}
                    <a href="/agent/" className={getLinkClassName('/agent/')}>Agent</a>
                    <a href="/aigc/" className={getLinkClassName('/aigc/')}>AIGC</a>
                </nav>
            </div>

            <div className="md:hidden w-[38vw]">
                <div className="text-white font-bold text-lg tracking-wider">
                    <img src={logo} className="w-24" alt="" />
                </div>
            </div>

            <div className="absolute top-[100px] left-0 w-full bg-[#000000] border-t border-[#1a1a27]  py-4 z-10 md:hidden">
                <nav className='flex justify-evenly'>
                    <a href="https://www.bitplay.fun/" className={getLinkClassName('https://www.bitplay.fun/')}>Home</a>
                    <a href="/games/" className={getLinkClassName('/games/')}>Games</a>
                    {/* <a href="/spin/" className={getLinkClassName('/spin/')}>Mission</a> */}
                    {/* <a href="/gamecard/" className={getLinkClassName('/gamecard/')}>Game Card</a> */}
                    <a href="/agent/" className={getLinkClassName('/agent/')}>Agent</a>
                    <a href="/aigc/" className={getLinkClassName('/aigc/')}>AIGC</a>
                </nav>
            </div>

            <div className="flex items-center">
                <ConnectButton.Custom>
                    {({
                        account,
                        chain,
                        openAccountModal,
                        openChainModal,
                        openConnectModal,
                        authenticationStatus,
                        mounted,
                    }) => {
                        const ready = mounted && authenticationStatus !== 'loading';
                        const connected =
                            ready &&
                            account &&
                            chain &&
                            (!authenticationStatus ||
                                authenticationStatus === 'authenticated');

                        return (
                            <div
                                {...(!ready && {
                                    'aria-hidden': true,
                                    'style': {
                                        opacity: 0,
                                        pointerEvents: 'none',
                                        userSelect: 'none',
                                    },
                                })}
                            >
                                {(() => {
                                    if (!connected) {
                                        return (
                                            <div onClick={openConnectModal} className="w-[178px] h-[40px] p-1 bg-[#2631fb] rounded-full cursor-pointer text-white flex items-center justify-between transition-transform duration-150 ease-in-out transform active:scale-95">
                                                <span className='pl-3'>Connect Wallet</span>
                                                <div className="w-8 h-8 bg-[#d9d9d9] rounded-full flex justify-center items-center cursor-pointer">
                                                    <img src={vector} className="w-[18px] h-[17px]" alt="" />
                                                </div>
                                            </div>
                                        );
                                    }

                                    if (chain.unsupported) {
                                        return (
                                            <button onClick={openChainModal} type="button">
                                                Wrong network
                                            </button>
                                        );
                                    }

                                    return (
                                        <div className='lg:w-72  h-[40px] bg-[#2631fb] rounded-full flex justify-between items-center text-white p-1'>
                                            <div
                                                onClick={openChainModal}
                                                className='cursor-pointer lg:flex items-center justify-center ml-2 lg:block hidden'
                                            >
                                                {chain.hasIcon && (
                                                    <div
                                                        style={{
                                                            background: chain.iconBackground,
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: 999,
                                                            overflow: 'hidden',
                                                            marginRight: 4,
                                                        }}
                                                    >
                                                        {chain.iconUrl && (
                                                            <img
                                                                alt={chain.name ?? 'Chain icon'}
                                                                src={chain.iconUrl}
                                                                style={{ width: 20, height: 20 }}
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                                {chain.name}
                                            </div>
                                            <div className='text-[#8a8bfc] lg:block hidden'>|</div>
                                            <div onClick={openAccountModal} type="button" className='lg:ml-3 flex items-center justify-center cursor-pointer'>
                                                {account.displayName}
                                            </div>
                                            <div className='w-8 h-8 bg-[#d9d9d9] rounded-full flex justify-center items-center cursor-pointer' onClick={openAccountModal}>
                                                <img src={vector} className='w-[18px] h-[17px]' alt="" />
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>
                        );
                    }}
                </ConnectButton.Custom>
            </div>
        </div>
    );
}

export default Head;
